import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getSessionQuestions } from "../redux/actions/fluxoNSimilar";
import { resetLoading } from "../redux/slices/sessionSlice";
import type { AppDispatch } from "../redux/store";

interface SessionVerify {
  sessionId?: string;
  finalized?: boolean;
  product?: string;
  description?: string;
  httpStatus?: number;
}

interface UseSessionHandlerProps {
  sessionVerify: SessionVerify | null;
  setLoading: (value: boolean) => void;
  setModalDisplay: (value: boolean) => void;
  setModalProduct: (value: string | undefined) => void;
  setModalDesc: (value: string | undefined) => void;
}

export const useSessionHandler = ({
  sessionVerify,
  setLoading,
  setModalDisplay,
  setModalProduct,
  setModalDesc,
}: UseSessionHandlerProps) => {
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    const fetchData = async () => {
      dispatch(resetLoading());

      if (sessionVerify?.sessionId) {
        await dispatch(getSessionQuestions(sessionVerify.sessionId)).unwrap();
      }

      if (sessionVerify?.finalized === false) {
        setModalDisplay(true);
        setLoading(true);
        setModalProduct(sessionVerify.product);
        setModalDesc(sessionVerify.description);
        localStorage.setItem("finalizedSession", "false");
      }
    };

    if (sessionVerify) {
      fetchData();
    }

    if (sessionVerify?.httpStatus === 204) {
      setLoading(false);
    }
  }, [
    sessionVerify,
    dispatch,
    setLoading,
    setModalDisplay,
    setModalProduct,
    setModalDesc,
  ]);
};
